
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/identity-resolution/how-it-works",
      function () {
        return require("private-next-pages/identity-resolution/how-it-works.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/identity-resolution/how-it-works"])
      });
    }
  